import React, { createContext, type Context } from "react";
import { useState } from "owa-react";

type StatusBarZoomContextValue = {
    isEnabled: boolean;
    updateIsEnabled: (isEnabled: boolean) => void;
};

const defaultContextValue: StatusBarZoomContextValue = {
    isEnabled: false,
    updateIsEnabled: () => undefined,
};

export const StatusBarZoomContext: Context<StatusBarZoomContextValue> = createContext<StatusBarZoomContextValue>(defaultContextValue);

export const StatusBarZoomContextProvider: React.FunctionComponent<React.PropsWithChildren> = ({ children, }) => {
    const [isEnabled, setIsEnabled] = useState(false);
    const updateIsEnabled = React.useCallback((nextIsEnabled: boolean) => {
        setIsEnabled(nextIsEnabled);
    }, []);
    const contextValue = React.useMemo(() => ({ isEnabled, updateIsEnabled }), [isEnabled, updateIsEnabled]);
    
    return (<StatusBarZoomContext.Provider value={contextValue}>
            {children}
        </StatusBarZoomContext.Provider>);
};

export function useStatusBarZoomContext(): StatusBarZoomContextValue {
    return React.useContext(StatusBarZoomContext);
}
